<img class="action-button" *ngIf="showIcon()" src="/content/images/icons/info.png" height="40" width="40" (click)="toggleChart()">
<div id="tempSignalChart" [hidden]="!showChart" class="temporary-signal-chart"></div>
